import Vue from 'vue'
import Router from 'vue-router'
import Homepage from '../components/Homepage'
import ProductList from '../components/ProductList'
import ProductDetailPage from '../components/ProductDetailPage'
import ProductLeaderboardPage from '../components/ProductLeaderboardPage'
// import Cart from '../components/Cart'
import Payment from '../components/Payment'
import AddressPage from '../components/AddressPage'
import ThankYou from '../components/ThankYou'
import LoginPage from '../components/LoginPage'
import RegisterPage from '../components/RegisterPage'
import ProfilePage from '../components/ProfilePage'
import MyPagePage from '../components/MyPagePage'
import LogoutPage from '../components/LogoutPage'
import UploadSlip from '../components/UploadSlip'
import ForgotPassword from '../components/ForgotPassword'
import ResetPassword from '../components/ResetPassword'
import Terms from '../components/Terms'
import Privacy from '../components/Privacy'
import Credits from '../components/Credits'

import OrderList from '../components/OrderList'
import OrderDetail from '../components/OrderDetail'

import Error401 from '../components/401'
import Error403 from '../components/403'
import Error500 from '../components/500'

import Policy from '../components/Policy'

import PagePage from '../components/PagePage'
import CreatePagePage from '../components/CreatePagePage'

import PageList from '../components/PageList'

import store from '../store'
import { INVOICE_STATUSES, INVOICE_SUBSTATUSES } from '../utils'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/page-list',
      name: 'PageList',
      component: PageList
    },
    {
      path: '/',
      name: 'homepage',
      component: Homepage
    },
    {
      path: '/products',
      name: 'products_list',
      component: ProductList,
      redirect: '/'
    },
    {
      path: '/orders',
      name: 'orders_list',
      component: OrderList,
      meta: {
        requiredLogin: true
      }
    },
    {
      path: '/user/pages',
      name: 'user_pages',
      component: MyPagePage,
      meta: {
        requiredLogin: true
      }
    },
    {
      path: '/orders/:id',
      name: 'orders_detail',
      component: OrderDetail,
      meta: {
        requiredLogin: false
      }
    },
    {
      path: '/products/:sku',
      name: 'product_detail',
      component: ProductDetailPage,
      meta: {
        bodyClasses: 'product-page'
      }
    },
    {
      path: '/pages/:id',
      name: 'page',
      component: PagePage
    },
    {
      path: '/leaderboard/:sku',
      name: 'product_leaderboard',
      component: ProductLeaderboardPage
    },
    // {
    //   path: '/cart',
    //   name: 'cart',
    //   component: Cart,
    //   meta: {
    //     hideCartStatusIcon: false,
    //     checkInApp: true
    //   }
    // },
    {
      path: '/checkout',
      name: 'checkout',
      component: Payment,
      meta: {
        hideCartStatusIcon: true,
        requiredLogin: false,
        focusMode: true,
        navTitle: 'ชำระเงิน',
        bodyClasses: 'body__wrapper',
        checkInApp: true
      }
    },
    {
      path: '/edit-address',
      name: 'edit_address',
      component: AddressPage,
      props: {
        back: true
      },
      meta: {
        hideCartStatusIcon: true,
        requiredLogin: true,
        focusMode: true,
        navTitle: 'แก้ไขที่อยู่',
        bodyClasses: 'body__wrapper'
      }
    },
    {
      path: '/thank-you',
      name: 'thank_you',
      component: ThankYou,
      meta: {
        hideCartStatusIcon: true,
        requiredLogin: false,
        focusMode: false,
        navTitle: '',
        bodyClasses: 'hide-nav'
      }
    },
    {
      path: '/thank-you/:orderId',
      name: 'thank_you_order',
      component: ThankYou,
      meta: {
        hideCartStatusIcon: true,
        requiredLogin: false,
        focusMode: false,
        navTitle: '',
        bodyClasses: 'hide-nav'
      }
    },
    {
      path: '/user/login',
      name: 'user_login',
      component: LoginPage
    },
    {
      path: '/user/register',
      name: 'user_register',
      component: RegisterPage
    },
    {
      path: '/user/forgot',
      name: 'user_forgot',
      component: ForgotPassword
    },
    {
      path: '/user/reset-password',
      name: 'user_password',
      component: ResetPassword
    },
    {
      path: '/user/profile',
      name: 'user_profile',
      component: ProfilePage,
      meta: {
        requiredLogin: true
      }
    },
    {
      path: '/user/logout',
      name: 'user_logout',
      component: LogoutPage,
      meta: {
        requiredLogin: true
      }
    },
    {
      path: '/upload-slip/:orderId?',
      name: 'upload-slip',
      component: UploadSlip,
      meta: {
        hideCartStatusIcon: true,
        requiredLogin: false,
        checkInApp: true
      }
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms,
      meta: {
        requiredLogin: false
      }
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy,
      meta: {
        requiredLogin: false
      }
    },
    {
      path: '/:sku/pages/create',
      name: 'create_page_page',
      component: CreatePagePage,
      meta: {
        bodyClasses: 'create-page'
      }
    },
    {
      path: '*',
      name: 'pages',
      component: PagePage
    },
    {
      path: '/401',
      name: 'error401',
      component: Error401
    },
    {
      path: '/403',
      name: 'error403',
      component: Error403
    },
    {
      path: '/500',
      name: 'error500',
      component: Error500
    },
    {
      path: '/policy',
      name: 'policy',
      component: Policy
    },
    {
      path: '/credits',
      name: 'credits',
      component: Credits
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    // TODO: find out why this features is not work
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  router.app.$utils.gaPageView(to.path)

  if (router.app.$outdated) {
    router.app.$outdated.checkBrowser(to.meta.checkInApp)
  } else {
    setTimeout(() => router.app.$outdated.checkBrowser(to.meta.checkInApp), 1000)
  }

  store.dispatch('initUser')

  if (to.meta.hideCartStatusIcon) {
    store.dispatch('toggleCartStatus', false)
  } else {
    store.dispatch('toggleCartStatus', true)
  }

  if (to.meta.focusMode) {
    store.dispatch('setNavFocusMode', true)
  } else {
    store.dispatch('setNavFocusMode', false)
  }

  if (to.meta.navTitle) {
    store.dispatch('setNavTitle', to.meta.navTitle)
  } else {
    store.dispatch('setNavTitle', '')
  }

  if (to.meta.requiredLogin) {
    if (!store.state.token) {
      next(`/user/login?next=${to.path}`)
    }
  }

  if (to.meta.bodyClasses) {
    router.app.$utils.setBodyClasses(to.meta.bodyClasses)
  } else {
    router.app.$utils.setBodyClasses('')
  }

  store.dispatch('initCart').then(() => {
    console.log('initCart')
    let currentOrderId
    if (to.query && to.query.orderId) {
      currentOrderId = to.query.orderId
    } else if (store.state.orderId) {
      currentOrderId = store.state.orderId
    }

    if (!to.query.orderId && (!store.state.paymentMethod || store.state.paymentMethod === 'bank_transfer' || !store.state.orderId)) {
      return
    }
    console.log('currentOrderId', currentOrderId)

    Vue.prototype.$modal.show({
      title: 'มีรายการที่ประมวลผลค้างอยู่',
      text: `กรุณารอสักครู่ ระบบกำลังตรวจสอบข้อมูลสถานะของการบริจาค หมายเลข ${currentOrderId}`,
      okButton: false,
      showLoader: true
    })

    const startedAt = new Date()

    // router.app.$http.post(`invoices/${store.state.orderId}/recheck`, { client_id: store.state.clientId })
    let recheckInterval = Vue.config.PAYMENT_RECHECK_INTERVAL
    let recheckDelay = 2000
    // Delay faster uncomment below
    // if (store.state.paymentMethod === 'internet_banking') {
    //   recheckInterval = 200
    //   recheckDelay = 1
    // }

    console.log('b setTimeout')

    setTimeout(() => { // we set delay here to softly allow user to read modal before it done.
      let latestSubStatus = INVOICE_SUBSTATUSES.NONE
      console.log('setTimeout')

      let isWorking = false
      let currentInvoice = {}

      const t = setInterval(() => {
        if ((new Date()) - startedAt > Vue.config.PAYMENT_RECHECK_TIMEOUT) {
          if (currentInvoice.payment_method === '2c2p:123' && currentInvoice.substatus === INVOICE_SUBSTATUSES.PAYMENT_PENDING) {
            clearInterval(t)
            store.dispatch('clearCart').then(() => {
              router.push('/')
            })

            Vue.prototype.$modal.show({
              title: 'ขอบคุณ',
              text: `หากท่านเลือกจ่ายที่ counter หรือ ATM กรุณาชำระเงินภายใน 2 วัน`,
              okButtonText: 'ตกลง'
            })
            return
          }

          clearInterval(t)
          const orderId = store.state.orderId
          store.dispatch('setOrderId', null)
          currentOrderId = null
          delete to.query.orderId
          Vue.prototype.$modal.show({
            title: 'มีบางอย่างผิดพลาด',
            text: `เราไม่สามารถตรวจสอบสถานะของรายการหมายเลข ${orderId} ได้ กรุณาติดต่อ ${Vue.config.WEBSITE_EMAIL} เพื่อตรวจสอบอีกครั้ง`,
            okButtonText: 'ไปหน้าชำระเงิน',
            ok: () => {
              router.push('/checkout')
            }
          })
        }

        if (isWorking) {
          return
        }
        isWorking = true
        if (currentOrderId && to.query.orderId || (new Date()) - store.state.orderIdTimestamp > Vue.config.PAYMENT_TIMEOUT || store.state.paymentMethod === 'internet_banking') {
          // get order status
          let retrieve = (latestSubStatus === INVOICE_SUBSTATUSES.PAYMENT_TIMEOUT || latestSubStatus === INVOICE_SUBSTATUSES.PAYMENT_PENDING)
          let promise = router.app.$utils.getInvoice(currentOrderId, retrieve)
            .then(invoice => {
              currentInvoice = invoice
              latestSubStatus = invoice.substatus

              if (invoice.status === INVOICE_STATUSES.PAID) {
                clearInterval(t)

                Vue.prototype.$modal.hide()
                store.dispatch('clearCart')
                router.push(`/thank-you/${currentOrderId}`)
                return
              }

              if (invoice.status === INVOICE_STATUSES.WAIT_FOR_APPROVE && invoice.substatus === INVOICE_SUBSTATUSES.ISSUE_PENDING) {
                clearInterval(t)
                store.dispatch('clearCart')

                Vue.prototype.$modal.show({
                  title: 'มีบางอย่างไม่ถูกต้อง',
                  text: `ระบบพบว่าคุณได้ชำระเงินแล้ว แต่ยังมีบางอย่างไม่ถูกต้อง กรุณาติดต่อผู้ดูแลระบบเพื่อสอบถามข้อมูลเพิ่มเติม<br><br>หมายเลขอ้างอิง: ${invoice.order_id}`,
                  okButtonText: 'ตกลง',
                  ok: () => {
                    router.push('/')
                  }
                })
                return
              }

              if (invoice.substatus === INVOICE_SUBSTATUSES.PAYMENT_TIMEOUT || invoice.substatus === INVOICE_SUBSTATUSES.PAYMENT_PENDING) {
                // Do nothing
              } else if (invoice.substatus === INVOICE_SUBSTATUSES.ERROR) {
                clearInterval(t)
                store.dispatch('resetPayment')

                Vue.prototype.$modal.show({
                  title: 'ทำรายการไม่สำเร็จหรือผิดพลาด',
                  text: 'และระบบยังไม่ได้ทำการตัดเงินของคุณ กรุณาไปหน้าชำระเงินอีกครั้ง ขออภัยในความผิดพลาด',
                  okButtonText: 'ไปหน้าชำระเงิน',
                  ok: () => {
                    router.push('/checkout')
                  }
                })
              } else if (invoice.substatus !== INVOICE_SUBSTATUSES.NONE) {
                clearInterval(t)
                store.dispatch('resetPayment')

                Vue.prototype.$modal.show({
                  title: 'รายการหมดอายุแล้ว',
                  text: 'และระบบยังไม่ได้ทำการตัดเงินของคุณ กรุณาไปหน้าชำระเงินอีกครั้ง ขออภัยในความผิดพลาด',
                  okButtonText: 'ไปหน้าชำระเงิน',
                  ok: () => {
                    router.push('/checkout')
                  }
                })
              }
            })
            .catch(err => {
              console.log(err)
            })

          promise.then(() => {
            isWorking = false
          })
        }
      }, recheckInterval)
    }, recheckDelay)
  })

  next()
})

router.afterEach((to, from) => {
  store.dispatch('setPreviousRoute', from)

  if (to.name === 'checkout') {
    store.dispatch('setRouteBeforeCheckout', from)
  }
  window.scrollTo(0, 0)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js